import { STARTED_BOOKING_DATA_KEY } from '../constants';
import { NavigateFunction } from 'react-router-dom';

interface BookingData {
  facilityId?: string | null;
  sizeCodeId?: string | null;
  boxId?: string | null;
}

export const setBookingDataToLocalStorage = (data: BookingData, navigate: NavigateFunction): void => {
  const existingRaw = localStorage.getItem(STARTED_BOOKING_DATA_KEY);
  const existingParams = new URLSearchParams(existingRaw || '');

  Object.entries(data).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') {
      existingParams.delete(key);
    } else {
      existingParams.set(key, value);
    }
  });

  localStorage.setItem(STARTED_BOOKING_DATA_KEY, existingParams.toString());

  const currentQueryParams = new URLSearchParams(window.location.search);

  Object.entries(data).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') {
      currentQueryParams.delete(key);
    } else {
      currentQueryParams.set(key, value);
    }
  });

  const newUrl = `${window.location.pathname}?${currentQueryParams.toString()}`;

  navigate(newUrl, { replace: true });
};
